module.exports = ".line{width:100%;border-top:3px solid #e5e5e5;position:relative;top:11px}.line.active-line{border-top:3px solid #55b1bd}\n"